import React from "react"

export const STATIC_SEO_DATA = {
  Home: {
    title: "Live Wedding Band - Music Entertainment for your Special Day",
    description:
      "Looking For An Awesome & Reliable Wedding Band? Live Music For Your Ceremony, Drinks or Reception. Get A Free Quote Online!",
  },
  Quote: {
    title: "Live Wedding Bands Instant Quote",
    description:
      "Use our package builder and create an instant quote for your wedding music entertainment",
  },
  EnquiryThankYou: {
    title: "Thank You for Your Enquiry",
    description:
      "Thank you for your enquiry! We've received your request for booking music and will get back to you shortly.",
  },
  CallbackThankYou: {
    title: "Thank You for Your Callback",
    description:
      "Thank you for your callback! We've received your request for booking music and will get back to you shortly.",
  },
  Preview: {
    title: "Preview Page",
  },
}

export const getDynamicSeoData = (pageContext, hasTemplateTitle = false) => {
  return {
    title: pageContext?.attributes?.headTitle || pageContext?.attributes?.title,
    description:
      pageContext?.attributes?.headDesc || pageContext?.attributes?.description,
    image: pageContext?.attributes?.image?.data?.attributes?.url,
    readingTime: pageContext?.attributes?.readingTime,
    author: pageContext?.attributes?.author,
    imageWidth: pageContext?.attributes?.image.data?.attributes?.width,
    imageHeight: pageContext?.attributes?.image.data?.attributes?.height,
    hasTemplateTitle,
  }
}

export const getBlogSeoData = (pageContext, category, site) => {
  const blogSEOData = {
    default: {
      title: `Blog - Wedding Music Bands in ${site} - Red Soda Band`,
      description: `Blog articles on wedding entertainment, popular wedding songs, live wedding music bands and more by Red Soda Band`,
    },
    advice: {
      title: `ADVICE Archives | Wedding Music Bands in ${site} - Red Soda Band`,
      description: `ADVICE Archives in ${site} | Blog articles on wedding entertainment, popular wedding songs, live wedding music bands and more by Red Soda Band`,
    },
    inspiration: {
      title: `INSPIRATION Archives | Wedding Music Bands in ${site} - Red Soda Band`,
      description: `INSPIRATION Archives in ${site} | Blog articles on wedding entertainment, popular wedding songs, live wedding music bands and more by Red Soda Band`,
    },
    weddingmusic: {
      title: `WEDDING MUSIC Archives | Wedding Music Bands in ${site} - Red Soda Band`,
      description: `WEDDING MUSIC Archives in ${site} | Blog articles on wedding entertainment, popular wedding songs, live wedding music bands and more by Red Soda Band`,
    },
  }

  const currentCategoryData = blogSEOData[category] || blogSEOData["default"]

  return {
    title: currentCategoryData?.title,
    description: currentCategoryData?.description,
    hasTemplateTitle: false,
  }
}

export const getExtraMetaTagNode = extraMetaData =>
  (extraMetaData || []).map(metaData => {
    const { tag, ...args } = metaData ?? {}
    switch (tag) {
      case "link": {
        return <link {...args} key={args} />
      }
      default:
        return null
    }
  })
